'use strict';exports.__esModule = true;var _marked = require('marked');var _marked2 = _interopRequireDefault(_marked);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var convertStringToHTML = function convertStringToHTML() {var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var result = {};

  (0, _marked2.default)(value, { breaks: true }, function (err, htmlContent) {
    if (err) throw err;
    result = {
      htmlContent: htmlContent,
      content: value };

  });

  return result;
};exports.default =

convertStringToHTML;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/convertStringToHTML.js
// module id = 1294
// module chunks = 0